import { IApiBlacklistResult } from 'affiny-core/modules/api/models/blacklist/blacklist.types';
import { AffinyEndpoint } from '../affinyEndpoints/affiny.endpoints';

export const BlacklistResource = {
  getBlacklist: () =>
    AffinyEndpoint.Blacklists.url('/').get().json<IApiBlacklistResult>(),
  deleteBlacklist: (receiverId: string) =>
    AffinyEndpoint.Blacklist.url(`/${receiverId}`).delete().res(),
  postBlacklist: (receiverId: string) =>
    AffinyEndpoint.Blacklist.url(`/${receiverId}`).post().res(),
};
